import './OwnershipMark.css';

export type Ownership = 'you' | 'office' | 'view-only';

const OWNERSHIP_WORD: Record<Ownership, string> = {
  you: 'Yours',
  office: 'Office',
  'view-only': 'View only',
};

export interface OwnershipMarkProps {
  ownership: Ownership;
  /** Renders the visible-but-locked affordance beside the mark (wf02's
   *  masked-pay pattern): the value stays readable, the control is locked,
   *  and the way forward is an ask — C3's on_exceed at field level. Only
   *  meaningful with ownership "view-only". */
  onRequestChange?: () => void;
}

// Field-ownership mark (decision 2d089cf9) — who may edit this field: you /
// the office / nobody-here. The C3 authority manifest's `fields` section is
// this component's data source. A mark is information, not decoration — it
// is always a word, never colour alone.
export function OwnershipMark({ ownership, onRequestChange }: OwnershipMarkProps) {
  return (
    <span class={`vw-ownership-mark vw-ownership-mark--${ownership}`}>
      <span class="vw-ownership-mark__word">{OWNERSHIP_WORD[ownership]}</span>
      {ownership === 'view-only' && onRequestChange ? (
        <button type="button" class="vw-ownership-mark__ask" onClick={onRequestChange}>
          Request a change
        </button>
      ) : null}
    </span>
  );
}
